import React, { Component, createRef } from "react";
import { withStyles } from "@material-ui/core/styles";
import Link from "@material-ui/core/Link";
import Paper from "@material-ui/core/Paper";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import TextField from "@material-ui/core/TextField";

import FastRewindIcon from "@material-ui/icons/FastRewind";
import FastForwardIcon from "@material-ui/icons/FastForward";
import ArrowLeftIcon from "@material-ui/icons/ArrowLeft";
import ArrowRightIcon from "@material-ui/icons/ArrowRight";

import { useStyles } from "./AdminControlPanel.css";

class AdminControlPanel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageRef: createRef(),
    };
  }

  handleWheel = (refValue) => {
    refValue.current.blur();
    setTimeout(() => refValue.current.focus(), 100);
  };

  render() {
    const { classes, title, pageNumber, totalPages } = this.props;
    return (
      <div style={{ padding: 10, textAlign: "center" }}>
        <Link
          href="/"
          style={{ fontSize: 30, textDecoration: "none", color: "#181818" }}
        >
          Digi-Book
        </Link>
        <div>{title}</div>
        <Paper className={classes.paper}>
          <div className={classes.paperBody}>
            <IconButton
              disableRipple
              disabled={pageNumber === 1 ? true : false}
              style={{ background: "transparent" }}
              onClick={() => this.props.handlePageNumber(1)}
            >
              <Tooltip arrow title="To First Page" className={classes.tooltip}>
                <FastRewindIcon
                  style={{
                    width: 30,
                    height: 30,
                    color: pageNumber === 1 ? "#636363" : "#090909",
                  }}
                />
              </Tooltip>
            </IconButton>
            <IconButton
              disableRipple
              disabled={pageNumber === 1 ? true : false}
              style={{ background: "transparent" }}
              onClick={() => this.props.handlePageNumber(pageNumber - 1)}
            >
              <Tooltip arrow title="Previous Page" className={classes.tooltip}>
                <ArrowLeftIcon
                  style={{
                    width: 40,
                    height: 40,
                    color: pageNumber === 1 ? "#636363" : "#090909",
                  }}
                />
              </Tooltip>
            </IconButton>
            <div className={classes.paperBody}>
              <div style={{ marginRight: 5 }}>Page</div>
              <TextField
                name="title"
                type="number"
                required
                fullWidth
                placeholder="Page Number"
                variant="outlined"
                margin="normal"
                style={{ marginRight: 5, width: "50%" }}
                InputProps={{
                  classes: {
                    root: classes.inputRoot,
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                  inputProps: { min: 1, max: totalPages },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                inputRef={this.state.pageRef}
                onWheel={() => this.handleWheel(this.state.pageRef)}
                value={pageNumber}
                onChange={(e) => this.props.handlePageNumber(e.target.value)}
              />
              <div style={{ marginRight: 5 }}>of</div>
              <div style={{ marginRight: 5 }}>{totalPages}</div>
            </div>
            <IconButton
              disableRipple
              disabled={pageNumber === totalPages ? true : false}
              style={{ background: "transparent" }}
              onClick={() => this.props.handlePageNumber(pageNumber + 1)}
            >
              <Tooltip arrow title="Next Page" className={classes.tooltip}>
                <ArrowRightIcon
                  style={{
                    width: 40,
                    height: 40,
                    color: pageNumber === totalPages ? "#636363" : "#090909",
                  }}
                />
              </Tooltip>
            </IconButton>
            <IconButton
              disableRipple
              disabled={pageNumber === totalPages ? true : false}
              style={{ background: "transparent" }}
              onClick={() => this.props.handlePageNumber(totalPages)}
            >
              <Tooltip arrow title="To Last Page" className={classes.tooltip}>
                <FastForwardIcon
                  style={{
                    width: 30,
                    height: 30,
                    color: pageNumber === totalPages ? "#636363" : "#090909",
                  }}
                />
              </Tooltip>
            </IconButton>
          </div>
        </Paper>
      </div>
    );
  }
}

export default withStyles(useStyles)(AdminControlPanel);
